<!-- Sub Header -->
<div class="subheader">
    <div class="subheader-toolbar">
        <h1>{{title}}</h1>
        <breadcrumb *ngIf="showBreadcrumbs" [useBootstrap]='false'></breadcrumb>
    </div>
    <ng-content></ng-content>
</div>